import React, { useRef } from 'react';
import { injectIntl } from 'react-intl';
import {
  CtaButton,
  CurrentLicense,
  CurrentLicenseDescription,
  EctlDescription,
  EctlExpiration,
  ectlListCss,
  EctlRecord,
  Product,
  ProductDescription,
  ProductName
} from './components';
import { messages } from './messages';
import { OriginalEctlRecordProps } from './models';
import {
  generateEctlExpirationMessage,
  getStyleForEctlElig,
  transformEctlRecordData
} from './utils/ectl-record-utils';

function EctlRecordComponent({
  originalEctlRecord,
  activateTrialBaseUrl,
  activateUrlParameterKeys,
  handleSelectedEctlIdChanged,
  selectedEctlId,
  intl,
  activateOneYearCloudTrial
}: OriginalEctlRecordProps & {
  handleSelectedEctlIdChanged?: (newValue: string) => void;
  selectedEctlId: string;
  activateTrialBaseUrl: string;
  activateUrlParameterKeys?: string[];
  activateOneYearCloudTrial?: boolean;
}) {
  const handleRecordClicked = () => {
    if (
      radioInputRef &&
      radioInputRef.current &&
      radioInputRef.current.checked
    ) {
      radioInputRef.current.checked = true;
    }
    if (handleSelectedEctlIdChanged) {
      handleSelectedEctlIdChanged(
        transformedEctlRecord.supportEntitlementNumber
      );
    }
  };

  const radioInputRef = useRef<HTMLInputElement>(null);

  const transformedEctlRecord = transformEctlRecordData({
    originalEctlRecord,
    intl,
    activateTrialBaseUrl,
    activateUrlParameterKeys
  });

  return (
    <EctlRecord>
      {/*
        TODO: move this to the ectl-list component to avoid duplicate style tags in rendered output,
        but for some reason importing ectl-record's components folder would not compile in storybook
        but would compile in ectl-record and ectl-list folders (??).
        */}
      <style>{ectlListCss}</style>

      <div
        className={
          transformedEctlRecord.ectlExpirationDate
            ? 'ectl-record-ctrl-claimed'
            : selectedEctlId !== transformedEctlRecord.supportEntitlementNumber
            ? 'ectl-record-ctrl'
            : 'ectl-record-ctrl-selected'
        }
        onClick={
          transformedEctlRecord.ectlExpirationDate
            ? undefined
            : handleRecordClicked
        }
      >
        {transformedEctlRecord.ectlExpirationDate ? (
          ''
        ) : (
          <div className="radio-button">
            <input
              ref={radioInputRef}
              type="radio"
              name="ectlRadioGroup"
            ></input>
          </div>
        )}
        <div className="ectl-record">
          <Product>
            <ProductName>
              {transformedEctlRecord.installType}&nbsp;|&nbsp;
              <ProductDescription>
                {transformedEctlRecord.numberOfSeats}
                &nbsp;{transformedEctlRecord.numberOfSeatsUnit}&nbsp;|&nbsp;
                {transformedEctlRecord.purchaseType}
              </ProductDescription>
            </ProductName>
          </Product>
          <CurrentLicense>
            <CurrentLicenseDescription>
              {transformedEctlRecord.supportEntitlementNumber} |&nbsp;
              {intl.formatMessage(messages.supportExpirationDate, {
                theDate: intl.formatDate(
                  new Date(transformedEctlRecord.supportExpirationDate)
                )
              })}
            </CurrentLicenseDescription>
          </CurrentLicense>
          <EctlDescription>
            <EctlExpiration style={getStyleForEctlElig(transformedEctlRecord)}>
              {generateEctlExpirationMessage({
                transformedEctlRecord,
                intl,
                activateOneYearCloudTrial
              })}
            </EctlExpiration>
          </EctlDescription>
        </div>
        {transformedEctlRecord.ectlExpirationDate ? (
          ''
        ) : (
          <div className="ectl-cta">
            <CtaButton
              appearance="primary"
              href={transformedEctlRecord.activateTrialUrl}
              isDisabled={
                selectedEctlId !==
                transformedEctlRecord.supportEntitlementNumber
              }
            >
              {intl.formatMessage(messages.ctaButtonText)}
            </CtaButton>
          </div>
        )}
      </div>
    </EctlRecord>
  );
}

EctlRecordComponent.messages = messages;

export default injectIntl(EctlRecordComponent);
